import React from "react";
import useAuthStore from "../store/authStore";
import { toast } from "sonner";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "../components/ui/dialog";
import { Button } from "../components/ui/button";
import { UserPen } from "lucide-react";
import api from "../utils/api";

const ProfileEdit = () => {
  const [showProfileDialog, setShowProfileDialog] = React.useState(false);
  const { user } = useAuthStore();
  const [editedName, setEditedName] = React.useState(user.name);
  const [isSaving, setIsSaving] = React.useState(false);

  // optional: wenn Dialog neu geöffnet wird, Name zurücksetzen
  const handleSave = async () => {
    try {
      setIsSaving(true);
      await api.put(`/profile/${user.id}/name`, { new_name: editedName });
      toast.success("Profil erfolgreich gespeichert");
      setShowProfileDialog(false);
    } catch (error) {
      toast.error("Fehler beim Speichern des Profils", {
        description: error.response?.data?.detail || "Unbekannter Fehler",
      });
      setShowProfileDialog(false);
    } finally {
      setIsSaving(false);
    }
  };

  React.useEffect(() => {
    if (showProfileDialog) {
      setEditedName(user.name);
    }
  }, [showProfileDialog, user.name]);

  return (
    <div>
      <Button
        data-testid="profile-button"
        onClick={() => setShowProfileDialog(true)}
        variant="outline"
        size="sm"
        className="gap-2"
      >
        <UserPen className="h-4 w-4" />
      </Button>

      {/* dialog for editing profile */}
      <Dialog open={showProfileDialog} onOpenChange={setShowProfileDialog}>
        <DialogContent>
          <DialogHeader>
            {/* TODO: übersetzung in i18n */}
            <DialogTitle>Profil bearbeiten</DialogTitle>
            <DialogDescription></DialogDescription>
          </DialogHeader>
          <div className="space-y-4">
            <div className="space-y-2">
              <div className="space-y-1">
                <p className="text-sm text-muted-foreground">{user.email}</p>
              </div>
              <div className="space-y-1 ">
                <label className="block text-sm font-medium" htmlFor="name">
                  Name
                </label>
                <input
                  className="w-full rounded-md border border-gray-300 px-3 py-2 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500 dark:bg-gray-800 dark:border-gray-600 dark:focus:border-blue-400 dark:focus:ring-blue-400"
                  type="text"
                  id="name"
                  value={editedName}
                  onChange={(e) => setEditedName(e.target.value)}
                />
              </div>
            </div>
          </div>
          <div className="mt-6 flex justify-end gap-2">
            <Button
              variant="outline"
              onClick={() => setShowProfileDialog(false)}
              type="button"
            >
              Abbrechen
            </Button>
            <Button
              onClick={handleSave}
              disabled={isSaving || !editedName.trim()}
            >
              {/* TODO: übersetzung in i18n */}
              {isSaving ? "Speichern..." : "Speichern"}
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default ProfileEdit;
